export default "__VITE_ASSET__DmM4PWa9__"